module.exports = __webpack_public_path__ + "img/appbg.2431ef26.jpg";